export default __webpack_public_path__ + "static/media/sample-apartment.b343c4d7.jpg";